import React from 'react'
import ButtonBuyQuantityDefault from './ButtonBuyQuantityDefault'
import ButtonBuyQuantityEmex from './ButtonBuyQuantityEmex'

const ButtonBuyQuantity = ({ part, basketInfo, showQuantitySelect = true }) => {
    const basketQuantity = basketInfo['quantity']
    const useEmexLogic = basketQuantity > 0

    const ButtonBuyQuantity = useEmexLogic ? ButtonBuyQuantityEmex : ButtonBuyQuantityDefault

    return (
        <ButtonBuyQuantity
            part={part}
            basketInfo={basketInfo}
            showQuantitySelect={showQuantitySelect}
        />
    )
}

export default ButtonBuyQuantity
